// Client-seitiger Geburtsdatum-Helfer — Spiegel von server/utils/age.js.
//
// Dient NUR der frühen UI-Verzweigung (unter 13 blockieren, 13–15 zeigt die
// Eltern-Einverständnis-Checkbox). Der Server bleibt die maßgebliche Instanz
// (validateBirthdate + Alters-/Einwilligungs-Branch in server/auth.js) — hier
// wird nur gespiegelt, damit der Nutzer nicht erst nach dem Roundtrip abgewiesen
// wird. Kalenderbasiert + UTC, identisch zur Serverberechnung.

export type AgeVerificationBranch = 'adult' | 'teen_16_17' | 'teen_13_15' | 'child_under_13';

// Geburtsdatum ('YYYY-MM-DD') → Alter in ganzen Jahren oder null bei Fehler.
export function calculateAgeFromBirthdate(birthdate: string): number | null {
  if (!birthdate || typeof birthdate !== 'string') return null;
  const m = birthdate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const y = Number.parseInt(m[1], 10);
  const mo = Number.parseInt(m[2], 10);
  const d = Number.parseInt(m[3], 10);
  const bd = new Date(Date.UTC(y, mo - 1, d));
  if (Number.isNaN(bd.getTime())) return null;
  // Round-trip-Check: fängt nicht existierende Daten (31.02. usw.) ab.
  if (bd.getUTCFullYear() !== y || bd.getUTCMonth() !== mo - 1 || bd.getUTCDate() !== d) return null;
  const now = new Date();
  if (bd.getTime() > now.getTime()) return null;
  let age = now.getUTCFullYear() - y;
  const monthDiff = now.getUTCMonth() - (mo - 1);
  if (monthDiff < 0 || (monthDiff === 0 && now.getUTCDate() < d)) age -= 1;
  return age;
}

// Alter → Verifikations-Branch. null/undefined → child_under_13 (fail-safe).
export function getAgeVerificationBranch(age: number | null): AgeVerificationBranch {
  if (age == null || Number.isNaN(age)) return 'child_under_13';
  if (age >= 18) return 'adult';
  if (age >= 16) return 'teen_16_17';
  if (age >= 13) return 'teen_13_15';
  return 'child_under_13';
}
